import Cookies from "js-cookie";
import { React, useState, useEffect } from "react";

// external
import Navbar from "../../Components/Navbar";
import { fetchProfile } from "../../utils/fetchProfile";
import { styled } from "@mui/material/styles";
import {
  TextField,
  Autocomplete,
  Grid,
  InputLabel,
  MenuItem,
  Button,
} from "@mui/material";
import {
  fetchProductGroupMaster,
  fetchCreateSurveyProjectRDC,
  fetchCreateSurveyProjectAdhoc,
  fetchProjectSourceAdhoc,
  fetchCreateSurveyProjectRAK,
  fetchDetectProjectName,
  fetchCreateSurveyProjectRAK2B,
} from "./DataUtil";

//styles for open source
import "../../style/projectmanagement.css";

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  padding: "3px 10px",
  border: "1px solid",
  lineHeight: 1.5,
  backgroundColor: "#069DAE",
  fontFamily: ["Roboto"].join(","),
  "&:hover": {
    backgroundColor: "#0696A6",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#0062cc",
    borderColor: "#005cbf",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});

// Functional component for ProjectManagement
function AddProjectPage() {
  // initial
  const symbolRegex = /[.,;:'"&]/;
  const accessToken = Cookies.get("access_token") || "";
  const [isLoading, setIsLoading] = useState(false);
  const [dataProductGroupMasterList, setDataProductGroupMasterList] = useState(
    []
  );
  const [dataProjectSourceAdhocList, setDataProjectSourceAdhocList] = useState([]);
  const [baseSurveyDefaultAdhoc, setBaseSurveyDefaultAdhoc] = useState('');

  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);
  const [dataProfile, setDataProfile] = useState([]);

  const [newProjectData, setNewProjectData] = useState({
    client_code: process.env.REACT_APP_CLIENT_CODE,
    project_name: "",
    project_type: "",
    rdc_survey_start: "",
    rdc_survey_end: "",
    rak1_survey_start: "",
    rak1_survey_end: "",
    rak2_survey_start: "",
    rak2_survey_end: "",
    period: "",
    prev_period: "",
    survey_id: "",
    rak1_audit_plan_name: "",
    rak2_audit_plan_name: "",
    rdc_audit_plan_name: "",
    rak1_audit_plan_id: "",
    rak2_audit_plan_id: "",
    rdc_audit_plan_id: "",
    product_group_name: null,
    product_group_id: "",
    source_survey_id: "",
  });

  const dataProjectTypeOption = [
    {
      label: "RAK",
      id: "rak",
    },
    {
      label: "RAK2 B",
      id: "rak2_b",
    },
    {
      label: "RDC",
      id: "rdc",
    },
    {
      label: "RDC_MT",
      id: "rdc_mt",
    },
    {
      label: "RDC_PHARMACY",
      id: "rdc_pharmacy",
    },
    {
      label: "ADHOC",
      id: "adhoc",
    },
  ];

  // read
  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(accessToken, setDataProfile, setNotAllowAccessPage, [
        "TL",
        "COA",
        "13",
        "14",
      ]);
      fetchProductGroupMaster(
        accessToken,
        setIsLoading,
        setDataProductGroupMasterList
      );
      fetchProjectSourceAdhoc(
        accessToken,
        setIsLoading,
        setDataProjectSourceAdhocList,
        setBaseSurveyDefaultAdhoc,
        ["ADHOC", "RDC", "RDC_MT", "RDC_PHARMACY"]
      );
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setNewProjectData({
      ...newProjectData,
      [name]: value,
    });
  };

  const validProjectNameSymbolCheck = (projectName) => {
    // Validate the project name
    // symbol not allowing , . ; : \' " &
    if (symbolRegex.test(projectName)) {
      alert("Project name should not contain any symbols (, . ; : ' \" &)");
      return false;
    } else {
      return true;
    }
  };

  const PROJECT_CONFIG = {
    rdc: {
      requiredFields: ["rdc_survey_start", "rdc_survey_end"],
      forbiddenProductGroup: "msra",
      errorMessage:
        "RDC Survey Start dan RDC Survey End tidak boleh kosong.",
      createFn: fetchCreateSurveyProjectRDC,
    },
    rdc_mt: {
      requiredFields: ["rdc_survey_start", "rdc_survey_end"],
      forbiddenProductGroup: "msra",
      errorMessage:
        "RDC Survey Start dan RDC Survey End tidak boleh kosong.",
      createFn: fetchCreateSurveyProjectRDC,
    },
    rdc_pharmacy: {
      requiredFields: ["rdc_survey_start", "rdc_survey_end"],
      forbiddenProductGroup: "msra",
      errorMessage:
        "RDC Survey Start dan RDC Survey End tidak boleh kosong.",
      createFn: fetchCreateSurveyProjectRDC,
    },
    adhoc: {
      requiredFields: ["rdc_survey_start", "rdc_survey_end"],
      forbiddenProductGroup: "msra",
      errorMessage:
        "RDC Survey Start dan RDC Survey End tidak boleh kosong.",
      createFn: fetchCreateSurveyProjectAdhoc,
    },
    rak: {
      requiredFields: [
        "rak1_survey_start",
        "rak1_survey_end",
        "rak2_survey_start",
        "rak2_survey_end",
        "prev_period",
      ],
      forbiddenProductGroup: "rdc",
      errorMessage:
        "Prev Period, RAK1 & RAK2 Survey tidak boleh kosong.",
      createFn: fetchCreateSurveyProjectRAK,
    },

    rak2_b: {
      requiredFields: [
        "rak2_survey_start",
        "rak2_survey_end",
        "prev_period",
      ],
      forbiddenProductGroup: "rdc",
      errorMessage:
        "Prev Period, RAK2 Survey tidak boleh kosong.",
      createFn: fetchCreateSurveyProjectRAK2B,
    },
  };

  const hasEmptyFields = (obj) =>
    Object.values(obj).some((val) => val === "");

  const pickFields = (obj, fields) =>
    fields.reduce((acc, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});

  const handleSubmit = async () => {
    setIsLoading(true);

    try {
      const requestBody = { ...newProjectData };

      const masterCheck = {
        project_name: requestBody.project_name,
        project_type: requestBody.project_type,
        product_group_name: requestBody.product_group_name,
        period: requestBody.period,
      };

      if (hasEmptyFields(masterCheck)) {
        alert("Project Name, Project Type, Period dan Product Group tidak boleh kosong.");
        return;
      }

      const config = PROJECT_CONFIG[requestBody.project_type];

      if (!config) {
        alert("ada masalah sewaktu membuat project");
        return;
      }

      // 1. Required fields validation
      const requiredData = pickFields(requestBody, config.requiredFields);
      if (hasEmptyFields(requiredData)) {
        alert(config.errorMessage);
        return;
      }

      // 2. Product group validation
      if (
        requestBody.product_group_name.includes(
          config.forbiddenProductGroup
        )
      ) {
        alert(
          `Project dengan tipe ${requestBody.project_type} tidak boleh menggunakan product group ${config.forbiddenProductGroup}`
        );
        return;
      }

      // 3. Project name validation
      const isValidName = validProjectNameSymbolCheck(
        requestBody.project_name
      );
      if (!isValidName) return;

      // 4. Duplicate check
      const allowNewProjectCreated = await fetchDetectProjectName(
        accessToken,
        requestBody.project_name
      );

      if (allowNewProjectCreated !== "") {
        alert(allowNewProjectCreated);
        return;
      }

      // 5. Execute API
      await config.createFn(accessToken, requestBody);

    } catch (error) {
      console.error("Error creating Project:", error);
    } finally {
      setIsLoading(false);
    }
  };

  let dataProductGroupMasterListFormat = dataProductGroupMasterList;

  if (
    newProjectData.project_type === "rak" ||
    newProjectData.project_type === "rak2_b"
  ) {
    dataProductGroupMasterListFormat = dataProductGroupMasterList.filter(
      (data) => data.name.includes("msra")
    );
  }
  if (newProjectData.project_type === "rdc" ||
    newProjectData.project_type === "rdc_mt" ||
    newProjectData.project_type === "rdc_pharmacy") {
    dataProductGroupMasterListFormat = dataProductGroupMasterList.filter(
      (data) => data.name.includes("rdc")
    );
  }
  if (newProjectData.project_type === "adhoc") {
    dataProductGroupMasterListFormat = dataProductGroupMasterList;
  }

  if (notAllowAccessPage) {
    return (
      <div>
        <Navbar
          active="Project Management"
          initial={dataProfile.initial}
          role_code={dataProfile.role_code}
        />
        <div>Not allow to access this page</div>
      </div>
    );
  }
  return (
    <div>
      <Navbar
        active="Project Management"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      <div style={{ padding: "16px", maxWidth: "700px", margin: "0 auto" }}>
        <h2 style={{ textAlign: "center", mt: 2, mb: 2 }}>
          Add New Project
        </h2>
        <div>
          <TextField
            variant="filled"
            name="project_name"
            label="Project Name"
            value={newProjectData.project_name}
            onChange={handleInputChange}
            sx={{ width: "100%", mb: 2 }}
          />
          <TextField
            variant="filled"
            name="project_type"
            label="Project Type"
            select
            sx={{ width: "100%", mb: 2 }}
            value={newProjectData.project_type}
            onChange={(event) => {
              const { value } = event.target;
              setNewProjectData({
                ...newProjectData,
                project_type: value,
                product_group_name: null,
                source_survey_id: value === "adhoc" ? baseSurveyDefaultAdhoc : "",
              });
            }}
          >
            {dataProjectTypeOption.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          
          {
            newProjectData.project_type === "adhoc" ? (
            <TextField
              variant="filled"
              name="source_survey_id"
              label="Source Survey"
              select
              sx={{ width: "100%", mb: 2 }}
              value={newProjectData.source_survey_id}
              onChange={(event) => {
                const { value } = event.target;
                setNewProjectData({
                  ...newProjectData,
                  source_survey_id: value,
                  product_group_name: null,
                });
              }}
            >
              {dataProjectSourceAdhocList.map((option) => (
                <MenuItem key={option.survey_id} value={option.survey_id}>
                  {option.title}
                </MenuItem>
              ))}
            </TextField>
            ) : null
          }
          {newProjectData.project_type === "rak" ||
          newProjectData.project_type === "rak2_b" ? (
            <>
              {newProjectData.project_type === "rak" ? (
                <Grid container spacing={2}>
                  <Grid item sx={{ width: "50%" }}>
                    <InputLabel htmlFor="filled-adornment-rak1_survey_start">
                      RAK1 Survey Start
                    </InputLabel>
                    <TextField
                      variant="filled"
                      name="rak1_survey_start"
                      type="date"
                      value={newProjectData.rak1_survey_start}
                      onChange={handleInputChange}
                      sx={{ width: "100%", mb: 2 }}
                    />
                  </Grid>
                  <Grid item sx={{ width: "50%" }}>
                    <InputLabel htmlFor="filled-adornment-rak1_survey_end">
                      RAK1 Survey End
                    </InputLabel>
                    <TextField
                      variant="filled"
                      name="rak1_survey_end"
                      type="date"
                      value={newProjectData.rak1_survey_end}
                      onChange={handleInputChange}
                      sx={{ width: "100%", mb: 2 }}
                    />
                  </Grid>
                </Grid>
              ) : null}
              <Grid container spacing={2}>
                <Grid item sx={{ width: "50%" }}>
                  <InputLabel htmlFor="filled-adornment-rak2_survey_start">
                    RAK2 Survey Start
                  </InputLabel>
                  <TextField
                    variant="filled"
                    name="rak2_survey_start"
                    type="date"
                    value={newProjectData.rak2_survey_start}
                    onChange={handleInputChange}
                    sx={{ width: "100%", mb: 2 }}
                  />
                </Grid>
                <Grid item sx={{ width: "50%" }}>
                  <InputLabel htmlFor="filled-adornment-rak2_survey_end">
                    RAK2 Survey End
                  </InputLabel>
                  <TextField
                    variant="filled"
                    name="rak2_survey_end"
                    type="date"
                    value={newProjectData.rak2_survey_end}
                    onChange={handleInputChange}
                    sx={{ width: "100%", mb: 2 }}
                  />
                </Grid>
              </Grid>
              <TextField
                variant="filled"
                name="prev_period"
                label="Prev Period"
                type="number"
                value={newProjectData.prev_period}
                onChange={handleInputChange}
                sx={{ width: "100%", mb: 2 }}
              />
            </>
          ) : null}
          {(newProjectData.project_type === "rdc") |
          (newProjectData.project_type === "rdc_mt") |
          (newProjectData.project_type === "rdc_pharmacy") |
          (newProjectData.project_type === "adhoc") ? (
            <Grid container spacing={2}>
              <Grid item sx={{ width: "50%" }}>
                <InputLabel htmlFor="filled-adornment-rdc_survey_start">
                  RDC Survey Start
                </InputLabel>
                <TextField
                  variant="filled"
                  name="rdc_survey_start"
                  type="date"
                  value={newProjectData.rdc_survey_start}
                  onChange={handleInputChange}
                  sx={{ width: "100%", mb: 2 }}
                />
              </Grid>
              <Grid item sx={{ width: "50%" }}>
                <InputLabel htmlFor="filled-adornment-rdc_survey_end">
                  RDC Survey End
                </InputLabel>
                <TextField
                  variant="filled"
                  name="rdc_survey_end"
                  label=""
                  type="date"
                  value={newProjectData.rdc_survey_end}
                  onChange={handleInputChange}
                  sx={{ width: "100%", mb: 2 }}
                />
              </Grid>
            </Grid>
          ) : null}
          <TextField
            variant="filled"
            name="period"
            label="Period"
            type="number"
            value={newProjectData.period}
            onChange={handleInputChange}
            sx={{ width: "100%", mb: 2 }}
          />
          {newProjectData.project_type ? (
            <Autocomplete
              id="free-solo-product_group_name"
              name="product_group_name"
              value={newProjectData.product_group_name}
              onChange={(event, newValue) => {
                setNewProjectData({
                  ...newProjectData,
                  product_group_name: newValue,
                });
              }}
              disableClearable
              options={dataProductGroupMasterListFormat.map(
                (option) => option.name
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="filled"
                  label="Product Group Name"
                />
              )}
            />
          ) : null}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="outlined"
              disableRipple
              sx={{
                width: 182,
                mt: 2,
                mr: 2,
                height: 50,
                color: "#b34469",
                borderColor: "#b34469",
              }}
              onClick={() => window.location.href = "/project-management"}
            >
              Cancel
            </Button>
            <BootstrapButton
              variant="contained"
              disableRipple
              sx={{ width: 182, mt: 2, height: 50 }}
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "SUBMIT"}
            </BootstrapButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddProjectPage;
